export default {"src":"/_next/static/media/female_5.41b3a412.svg","height":144,"width":145,"blurWidth":0,"blurHeight":0};